import { Suspense } from 'react';
import SVG from 'react-inlinesvg';
import { LazyLoadImage } from '@proMaxComponents/lazy-load-image';

import { gu_isAppLayoutProMax } from '@utils/general-util';

const SVGRenderer = ({
    name = '',
    style = {},
    width = '100%',
    className = '',
    height = '100%',
    id = '',
    onClick = () => {},
    prefix = '',
    category = 'SVGMaster',
    onMouseEnter,
    onMouseLeave,
    ...rest
}) => {
    const props = {
        className: className,
        width: width,
        height: height,
        style: style,
        onClick: onClick,
        id: id,
        key: name,
        src: `/public/html/default_whitelabel/shared-image/icons/${category}/${name}.svg`,
        xmlns: 'http://www.w3.org/2000/svg',
        xmlnsXlink: 'http://www.w3.org/1999/xlink',
        prefix: prefix,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        ...rest,
    };

    return <Suspense fallback={<div className='loading-spinner' />}>{gu_isAppLayoutProMax() ? <LazyLoadImage {...props} isSvg={true} /> : <SVG {...props} />}</Suspense>;
};

SVGRenderer.displayName = 'SVGRenderer';
export default SVGRenderer;
